export default [
  { header: "Menú Compañía" },
  { icon: "fas fa-tractor", title: "Equipos", name: "pages/MachinesList" },
  { icon: "fas fa-grip-horizontal", title: "Demos", name: "pages/DemosList" },
  { icon: "fas fa-truck-moving", title: "Alquileres", name: "pages/RentsPage" },
  { icon: "fas fa-users", title: "Concesionarios", name: "pages/PremiumList" },
  {
    icon: "timeline",
    title: "Informe por equipo",
    name: "pages/MachinesRentsPage"
  }
];
